import styled, { css } from 'styled-components';
import { shade, tint } from 'polished';

interface IContainerProps {
  selected: boolean;
}

export const Container = styled.button<IContainerProps>`
  ${({ theme, disabled, selected }) => css`
    width: 150px;
    height: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    column-gap: 1rem;
    background-color: ${selected ? theme.colors.green : theme.colors.yellow};
    color: #fff;
    border-radius: ${theme.radius.default};
    font-size: 14px;
    font-weight: 400;

    ${disabled
      ? css`
          background-color: ${tint(
            0.3,
            selected ? theme.colors.green : theme.colors.yellow,
          )};
          cursor: not-allowed;
        `
      : css`
          :hover {
            background: ${shade(
              0.2,
              selected ? theme.colors.green : theme.colors.yellow,
            )};
            transition: 0.2s;
          }
        `}
  `}
`;
